import { useNavigate } from "react-router-dom";

import PropTypes from "prop-types";
function Header(props) {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/");
  };

  return (
    <header>
      <div className="container-lg px-3 p-lg-0 d-flex align-items-center">
        <button onClick={handleClick}>
          <img
            src={props.path}
            alt="ICICI Bank Logo"
            width={252}
            height={50}
            className="img-fluid"
          />
        </button>
        {/* <h2>Current Account</h2> */}
      </div>
    </header>
  );
}

Header.propTypes = {
  path: PropTypes.string,
};

export default Header;
